import { UPDATE_FIELD_FEEDBACK_FORM } from '../actions/setFeedBackFormAction';
import { VALIDATE_FEEDBACK_FORM } from '../actions/validateFeedBackFormAction';
import { CHECK_SUBMIT_EVENT } from '../actions/checkSubmitEventActions';
import { CLEAR_STATE } from '../actions/clearStateAction';

const initialState = {
  email: '',
  name: '',
  phone: '',
  message: '',
  emailValid: false,
  nameValid: false,
  phoneValid: false,
  messageValid: true,
  agreementValid: false,
  formValid: false,
  isValidated: false,
  isSubmit: false
};
  
export function feedBackFormReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FIELD_FEEDBACK_FORM: {
      const isValid = validateField(state, [action.fieldName], action.value);
      state =  { ...state, [action.fieldName]: action.value, [`${[action.fieldName]}` + `Valid`]: isValid};
      const isValidForm = state.emailValid && state.nameValid && state.phoneValid && state.agreementValid;
      return {...state, formValid: isValidForm, isSubmit: false}
    }
    case VALIDATE_FEEDBACK_FORM: {
      const isValid = state.emailValid && state.nameValid && state.phoneValid && state.agreementValid;
      return { ...state,  formValid: isValid};
    }
    case CHECK_SUBMIT_EVENT: {
      if (state.formValid) {
        return { ...state,  isValidated: true};
      } else {
        return { ...state, isSubmit: true};
      }
    }
    case CLEAR_STATE: {
      return {...initialState}
    }
    default:
      return state;
  }
}

function validateField(state, fieldName, value)  {
  switch(fieldName[0]) {
    case 'email': {
      const emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
      return !!emailValid;
    }
    case 'name': {
      const nameValid = value.length >= 2 && value.length <= 50 ? true : false;
      return nameValid;
    }
    case 'phone': {
      const phoneValid = value.match(/^[0-9 ()+-]+$/);
      return !!phoneValid;
    }
    case 'message': {
     return true
    }
    case 'agreement': {
      const agreementValid = state.agreementValid
      return !agreementValid
    }
    default:
      break;
  }  
}

  